export default __webpack_public_path__ + "static/media/018-chains.ca72baf5.png";